// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adhoc-landing {
  --bg: #FFFFFF;
  --panel: #F3F9F8;
  --panel-line: #E2EAE8;
  --blue: #1B6FAE;
  --blue-deep: #0E4E80;
  --teal: #3F9C8C;
  --green: #5DA73D;
  --green-deep: #3F7A2A;
  --ink: #152631;
  --midnight: #0B141B;
  --muted: #56666E;
  --line: #E3E9E8;
  --font-display: 'Bricolage Grotesque', sans-serif;
  --font-body: 'Inter', sans-serif;
  --font-mono: 'IBM Plex Mono', monospace;
  --grad: linear-gradient(135deg, var(--blue) 0%, var(--teal) 55%, var(--green) 100%);

  background: var(--bg);
  color: var(--ink);
  font-family: var(--font-body);
  line-height: 1.6;
  overflow-x: hidden;
  overflow-y: visible;
  min-height: 100%;
  position: relative;
}

.adhoc-landing * {
  box-sizing: border-box;
}

.adhoc-landing .wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 32px;
}

.adhoc-landing .eyebrow {
  font-family: var(--font-mono);
  font-size: 12.5px;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: var(--teal);
  font-weight: 500;
}

.adhoc-landing .btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 15px;
  color: #fff;
  background: var(--grad);
  border: none;
  padding: 14px 26px;
  border-radius: 9px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  text-decoration: none;
}

.adhoc-landing .btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px -8px rgba(27, 111, 174, 0.45);
}

.adhoc-landing .btn:focus-visible {
  outline: 2px solid var(--blue-deep);
  outline-offset: 3px;
}

.adhoc-landing .btn:disabled {
  opacity: 0.65;
  cursor: wait;
}

.adhoc-landing .btn .pulse-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  display: inline-block;
}

.adhoc-landing .btn-ghost {
  background: transparent;
  color: var(--ink);
  border: 1px solid var(--line);
  padding: 10px 18px;
  font-size: 14px;
}

.adhoc-landing .btn-ghost:hover:not(:disabled) {
  border-color: var(--teal);
  box-shadow: none;
  transform: none;
}

.adhoc-landing .price-chip {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-family: var(--font-mono);
  font-size: 13.5px;
}

.adhoc-landing .price-chip .was {
  color: var(--muted);
  text-decoration: line-through;
}

.adhoc-landing .price-chip .now {
  color: var(--green-deep);
  font-weight: 600;
  font-size: 16px;
}

.adhoc-landing .price-chip .off {
  background: #EAF4E5;
  color: var(--green-deep);
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.03em;
  padding: 3px 8px;
  border-radius: 5px;
}

.adhoc-landing .price-chip .off-promo {
  background: #FEE2E2;
  color: #B91C1C;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 4px 10px;
  border-radius: 6px;
  text-transform: uppercase;
}

.adhoc-landing .price-chip .usual {
  color: var(--muted);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 500;
}

.adhoc-landing .cta-offer-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.adhoc-landing .cta-offer-stack-center {
  align-items: center;
}

.adhoc-landing .cta-primary-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.adhoc-landing .cta-primary-wrap .btn-offer,
.adhoc-landing .cta-primary-wrap .btn-journey {
  width: 100%;
  max-width: 420px;
  justify-content: center;
}

.adhoc-landing .scan-credits-remaining {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
  text-align: center;
}

.adhoc-landing .nav-credits-continue {
  white-space: nowrap;
}

.adhoc-landing .btn-offer {
  background: #2D6A4F;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
  padding: 16px 28px;
  box-shadow: 0 8px 24px -6px rgba(45, 106, 79, 0.45);
  white-space: nowrap;
}

.adhoc-landing .btn-offer:hover:not(:disabled) {
  background: #40916C;
  box-shadow: 0 10px 28px -6px rgba(45, 106, 79, 0.5);
}

.adhoc-landing .btn-offer .btn-arrow {
  font-size: 18px;
  line-height: 1;
  margin-left: 2px;
}

.adhoc-landing .btn-nav-offer {
  font-size: 13px;
  padding: 10px 18px;
  white-space: nowrap;
  background: var(--midnight);
  color: #fff;
  border: 1px solid var(--midnight);
  border-radius: 999px;
  box-shadow: 0 6px 18px -8px rgba(11, 20, 27, 0.45);
}

.adhoc-landing .btn-nav-offer:hover:not(:disabled) {
  background: var(--ink);
  border-color: var(--ink);
  box-shadow: 0 8px 22px -8px rgba(11, 20, 27, 0.5);
  transform: translateY(-1px);
}

.adhoc-landing nav {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--line);
}

.adhoc-landing nav .wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 96px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.adhoc-landing .nav-logo img {
  height: 58px;
  width: auto;
  display: block;
  object-fit: contain;
}

.adhoc-landing .hero {
  position: relative;
  padding: 88px 0 110px;
  overflow: hidden;
}

.adhoc-landing .glow {
  position: absolute;
  top: -180px;
  right: -220px;
  width: 620px;
  height: 620px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(63, 156, 140, 0.10), transparent 70%);
  animation: adhoc-breathe 6s ease-in-out infinite;
  pointer-events: none;
}

@keyframes adhoc-breathe {
  0%, 100% { opacity: 0.7; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.07); }
}

.adhoc-landing .hero-grid {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  grid-template-rows: auto auto;
  gap: 32px 56px;
  align-items: start;
  position: relative;
  z-index: 1;
}

.adhoc-landing .hero-copy {
  grid-column: 1;
  grid-row: 1;
}

.adhoc-landing .hero h1 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(2.3rem, 4.4vw, 4rem);
  line-height: 1.07;
  letter-spacing: -0.01em;
  margin: 16px 0 22px;
}

.adhoc-landing .hero h1 em {
  font-style: normal;
  color: var(--green-deep);
}

.adhoc-landing .hero p.lede {
  font-size: 17.5px;
  color: var(--muted);
  max-width: 480px;
  margin-bottom: 0;
}

.adhoc-landing .hero-cta-row {
  grid-column: 1;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 0;
}

.adhoc-landing .phone-stage {
  grid-column: 2;
  grid-row: 1 / span 2;
  display: flex;
  justify-content: center;
  align-self: center;
}

.adhoc-landing .phone {
  width: 280px;
  background: #0E1A22;
  border: 6px solid #ECF1F0;
  border-radius: 36px;
  padding: 10px;
  box-shadow: 0 30px 60px -28px rgba(16, 40, 50, 0.35);
}

.adhoc-landing .screen {
  position: relative;
  background: var(--midnight);
  border-radius: 26px;
  overflow: hidden;
  height: 380px;
}

.adhoc-landing .scan-svg {
  width: 100%;
  height: 100%;
  display: block;
}

.adhoc-landing .scan-line {
  animation: adhoc-sweep 4s ease-in-out infinite alternate;
}

@keyframes adhoc-sweep {
  0% { transform: translateY(8px); opacity: 0.9; }
  100% { transform: translateY(312px); opacity: 0.9; }
}

.adhoc-landing .wave {
  stroke-dasharray: 560;
  animation: adhoc-draw 4s ease-in-out infinite alternate;
}

@keyframes adhoc-draw {
  0% { stroke-dashoffset: 560; }
  100% { stroke-dashoffset: 0; }
}

.adhoc-landing .readouts {
  position: absolute;
  bottom: 14px;
  left: 14px;
  right: 14px;
  display: flex;
  justify-content: space-between;
}

.adhoc-landing .readout {
  font-family: var(--font-mono);
}

.adhoc-landing .readout .num {
  font-size: 21px;
  font-weight: 500;
  color: #F4FAF8;
  display: block;
}

.adhoc-landing .readout .lbl {
  font-size: 10.5px;
  color: #7FE0C4;
  letter-spacing: 0.06em;
}

.adhoc-landing .section {
  padding: 90px 0;
}

.adhoc-landing .what-is {
  border-top: 1px solid var(--line);
}

.adhoc-landing .offers-section {
  border-top: 1px solid var(--line);
}

.adhoc-landing .offers-head {
  text-align: center;
  max-width: 640px;
  margin: 0 auto 48px;
}

.adhoc-landing .offers-head h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  line-height: 1.14;
  margin: 14px 0 14px;
}

.adhoc-landing .offers-head p {
  color: var(--muted);
  font-size: 16.5px;
}

.adhoc-landing .offers-bento {
  display: grid;
  grid-template-columns: 1.65fr 1fr;
  gap: 20px;
}

.adhoc-landing .offer-card {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  padding: 28px 32px 32px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
}

.adhoc-landing .offer-card-light {
  background: #fff;
  border: 1px solid var(--panel-line);
}

.adhoc-landing .offer-card-dark {
  background: var(--ink);
  border: 1px solid var(--ink);
  color: #fff;
}

.adhoc-landing .offer-card-dark p {
  color: rgba(255, 255, 255, 0.72);
}

.adhoc-landing .offer-card-accent {
  background: #EAF4E5;
  border: 1px solid #C8E6C0;
}

.adhoc-landing .offer-card-accent h3 {
  color: var(--green-deep);
}

.adhoc-landing .offer-card-accent p {
  color: #3D5C35;
  max-width: 420px;
}

.adhoc-landing .offer-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.adhoc-landing .offer-icon-rose {
  background: #FEE2E2;
  color: #DC2626;
}

.adhoc-landing .offer-icon-sky {
  background: rgba(255, 255, 255, 0.12);
  color: #7DD3FC;
}

.adhoc-landing .offer-icon-blue {
  background: #DBEAFE;
  color: var(--blue);
}

.adhoc-landing .offer-icon-green {
  background: rgba(93, 167, 61, 0.18);
  color: var(--green-deep);
}

.adhoc-landing .offer-card h3 {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 17px;
  margin: 0 0 10px;
  line-height: 1.3;
}

.adhoc-landing .offer-card-dark h3 {
  color: #fff;
}

.adhoc-landing .offer-card p {
  color: var(--muted);
  font-size: 14.5px;
  line-height: 1.55;
  margin: 0;
  flex: 1;
  max-width: 92%;
}

.adhoc-landing .offer-card-heart {
  min-height: 280px;
}

.adhoc-landing .offer-chart {
  display: block;
  width: 100%;
  max-width: 340px;
  height: auto;
  margin-top: 20px;
  opacity: 0.95;
}

.adhoc-landing .offer-card-vitals {
  min-height: 280px;
}

.adhoc-landing .offer-accent-ring {
  position: absolute;
  right: -40px;
  bottom: -40px;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 28px solid rgba(93, 167, 61, 0.12);
  pointer-events: none;
}

.adhoc-landing .how-section {
  border-top: 1px solid var(--line);
  background: var(--panel);
}

.adhoc-landing .how-head {
  text-align: center;
  max-width: 560px;
  margin: 0 auto 56px;
}

.adhoc-landing .how-head h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  line-height: 1.14;
  margin: 14px 0 14px;
}

.adhoc-landing .how-head p {
  color: var(--muted);
  font-size: 16.5px;
}

.adhoc-landing .how-rail {
  position: relative;
}

.adhoc-landing .how-rail-line {
  position: absolute;
  top: 34px;
  left: 8%;
  right: 8%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--panel-line) 8%,
    var(--teal) 50%,
    var(--panel-line) 92%,
    transparent 100%
  );
  pointer-events: none;
}

.adhoc-landing .how-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;
  align-items: start;
}

.adhoc-landing .how-step {
  position: relative;
  text-align: center;
  padding: 0 8px;
}

.adhoc-landing .how-step-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 22px;
}

.adhoc-landing .how-step-index {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: var(--green-deep);
  background: #fff;
  border: 1px solid var(--panel-line);
  border-radius: 6px;
  padding: 4px 10px;
  line-height: 1;
  box-shadow: 0 1px 0 rgba(21, 38, 49, 0.04);
}

.adhoc-landing .how-step-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid var(--panel-line);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--blue-deep);
  position: relative;
  box-shadow:
    0 1px 2px rgba(21, 38, 49, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.adhoc-landing .how-step-icon-wrap::before {
  content: '';
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  padding: 1px;
  background: var(--grad);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0.55;
  pointer-events: none;
}

.adhoc-landing .how-step h3 {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 16px;
  margin: 0 0 8px;
  color: var(--ink);
}

.adhoc-landing .how-step p {
  color: var(--muted);
  font-size: 14px;
  line-height: 1.55;
  margin: 0 auto;
  max-width: 220px;
}

.adhoc-landing .what-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
}

.adhoc-landing .what-grid h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  line-height: 1.14;
  margin: 14px 0 18px;
  max-width: 420px;
}

.adhoc-landing .what-grid .copy {
  color: var(--muted);
  font-size: 16.5px;
  max-width: 440px;
}

.adhoc-landing .facts {
  border-left: 1px solid var(--line);
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.adhoc-landing .fact {
  position: relative;
}

.adhoc-landing .fact::before {
  content: '';
  position: absolute;
  left: -41px;
  top: 7px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--teal);
}

.adhoc-landing .fact h3 {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}

.adhoc-landing .fact p {
  color: var(--muted);
  font-size: 14.5px;
}

.adhoc-landing .science-section {
  background: var(--ink);
  color: #fff;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.adhoc-landing .science-grid {
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 56px;
  align-items: center;
}

.adhoc-landing .science-media {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(127, 224, 196, 0.14);
  box-shadow:
    0 24px 48px -24px rgba(0, 0, 0, 0.65),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  aspect-ratio: 16 / 10;
  min-height: 280px;
}

.adhoc-landing .science-media-svg {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.adhoc-landing .science-wave {
  stroke-dasharray: 720;
  animation: science-wave-draw 4.5s ease-in-out infinite alternate;
}

.adhoc-landing .science-wave-dim {
  animation-delay: 0.6s;
}

@keyframes science-wave-draw {
  from { stroke-dashoffset: 80; }
  to { stroke-dashoffset: 0; }
}

.adhoc-landing .science-play {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--green);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 0 0 10px rgba(93, 167, 61, 0.18),
    0 16px 32px -8px rgba(0, 0, 0, 0.45);
  pointer-events: none;
}

.adhoc-landing .science-play svg {
  margin-left: 3px;
}

.adhoc-landing .eyebrow-light {
  color: #7FE0C4;
}

.adhoc-landing .science-copy h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(1.75rem, 3vw, 2.35rem);
  line-height: 1.18;
  margin: 14px 0 18px;
  max-width: 480px;
}

.adhoc-landing .science-accent {
  color: var(--green);
}

.adhoc-landing .science-lede {
  color: rgba(255, 255, 255, 0.78);
  font-size: 16px;
  line-height: 1.65;
  max-width: 520px;
  margin: 0 0 28px;
}

.adhoc-landing .science-points {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.adhoc-landing .science-points li {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 15px;
  line-height: 1.55;
}

.adhoc-landing .science-points strong {
  color: #fff;
  font-weight: 600;
}

.adhoc-landing .science-check {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: var(--green);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
  box-shadow: 0 4px 12px -4px rgba(93, 167, 61, 0.55);
}

.adhoc-landing .report-section {
  background: var(--panel);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.adhoc-landing .report-head {
  max-width: 560px;
  margin-bottom: 46px;
}

.adhoc-landing .report-head h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  line-height: 1.14;
  margin: 14px 0 14px;
}

.adhoc-landing .report-head p {
  color: var(--muted);
  font-size: 16.5px;
}

.adhoc-landing .report-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 18px;
}

.adhoc-landing .rcard {
  background: #fff;
  border: 1px solid var(--panel-line);
  border-radius: 14px;
  padding: 22px 22px 20px;
}

.adhoc-landing .rcard .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.adhoc-landing .rcard .cat {
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.adhoc-landing .rcard .metric {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 7px 0;
  border-top: 1px solid var(--panel-line);
}

.adhoc-landing .rcard .metric:first-of-type {
  border-top: none;
}

.adhoc-landing .rcard .metric .name {
  font-size: 13.5px;
  color: var(--muted);
}

.adhoc-landing .rcard .metric .val {
  font-family: var(--font-mono);
  font-size: 14px;
  font-weight: 500;
  color: var(--ink);
}

.adhoc-landing .journey-cta-section {
  background: var(--panel);
  border-top: 1px solid var(--line);
  padding: 64px 0 72px;
  display: flex;
  justify-content: center;
}

.adhoc-landing .journey-cta-wrap {
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  justify-content: center;
}

.adhoc-landing .journey-card {
  width: 100%;
  max-width: 620px;
  margin: 0;
  background: #fff;
  border: 1px solid var(--panel-line);
  border-radius: 28px;
  padding: 44px 44px 36px;
  box-shadow:
    0 24px 48px -28px rgba(21, 38, 49, 0.18),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;
  text-align: center;
  overflow: visible;
}

.adhoc-landing .journey-card-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.adhoc-landing .journey-card-head h2 {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(1.55rem, 3vw, 2rem);
  line-height: 1.2;
  margin: 0;
  color: var(--ink);
}

.adhoc-landing .journey-card-subhead {
  display: block;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.55;
  margin: 0;
  max-width: 460px;
}

.adhoc-landing .journey-offer-box {
  background: var(--panel);
  border: 1px solid var(--panel-line);
  border-radius: 16px;
  padding: 20px 22px;
  margin-bottom: 24px;
  text-align: left;
}

.adhoc-landing .journey-offer-label {
  display: block;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--green-deep);
  margin-bottom: 14px;
}

.adhoc-landing .journey-offer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.adhoc-landing .journey-offer-price {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 18px;
  color: var(--ink);
  margin: 0 0 4px;
}

.adhoc-landing .journey-offer-was {
  color: var(--muted);
  font-size: 14px;
  margin: 0;
}

.adhoc-landing .journey-save-badge {
  flex-shrink: 0;
  background: #EAF4E5;
  color: var(--green-deep);
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 13px;
  padding: 8px 14px;
  border-radius: 999px;
  white-space: nowrap;
}

.adhoc-landing .btn-journey {
  width: 100%;
  justify-content: center;
  background: var(--green-deep);
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
  padding: 17px 28px;
  box-shadow: 0 10px 28px -8px rgba(63, 122, 42, 0.45);
}

.adhoc-landing .btn-journey:hover:not(:disabled) {
  background: #4A8F32;
  box-shadow: 0 12px 32px -8px rgba(63, 122, 42, 0.5);
  transform: translateY(-1px);
}

.adhoc-landing .journey-card-cta {
  width: 100%;
}

.adhoc-landing .journey-card-cta .btn-nav-offer {
  width: 100%;
  justify-content: center;
  font-size: 16px;
  padding: 14px 28px;
}

.adhoc-landing .hero-cta-row .cta-offer-stack .btn-nav-offer {
  width: 100%;
  justify-content: center;
  font-size: 16px;
  padding: 14px 28px;
}

.adhoc-landing .journey-fine {
  margin: 18px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

.adhoc-landing footer {
  background: var(--ink);
  color: #fff;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 30px 0 48px;
  margin-bottom: env(safe-area-inset-bottom, 0);
}

.adhoc-landing footer .wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.adhoc-landing footer .brand {
  display: flex;
  align-items: center;
  gap: 9px;
}

.adhoc-landing footer .brand img {
  height: 38px;
  width: auto;
  display: block;
  object-fit: contain;
}

.adhoc-landing footer .brand span {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 17px;
  color: #fff;
}

.adhoc-landing footer .fine {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.72);
  max-width: 480px;
}

.adhoc-landing .pay-error {
  margin: 0 32px 16px;
  max-width: 1180px;
  margin-left: auto;
  margin-right: auto;
  padding: 14px 18px;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  border-radius: 10px;
  color: #B91C1C;
  font-size: 14px;
  font-weight: 500;
}

.adhoc-landing .pay-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(255, 255, 255, 0.88);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.adhoc-landing .pay-overlay-spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(27, 111, 174, 0.15);
  border-top-color: var(--blue);
  border-radius: 50%;
  animation: adhoc-spin 0.8s linear infinite;
}

@keyframes adhoc-spin {
  to { transform: rotate(360deg); }
}

.adhoc-landing .pay-overlay p {
  color: var(--muted);
  font-weight: 600;
  font-size: 15px;
}

.adhoc-landing .family-pack-buy-single {
  margin-top: 8px;
}

.adhoc-landing .journey-family-pack-link-compact {
  margin-top: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.adhoc-landing .hero-cta-row .journey-family-pack-link {
  margin-top: 4px;
  width: 100%;
  max-width: 420px;
}

.adhoc-landing .scan-credits-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.adhoc-landing .scan-credits-btn {
  width: 100%;
  max-width: 300px;
  justify-content: center;
  text-align: center;
}

.adhoc-landing .scan-credits-remaining {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
  text-align: center;
}

.adhoc-landing .hero-cta-row .scan-credits-cta {
  width: 100%;
  max-width: 420px;
}

.adhoc-landing .hero-cta-row .cta-offer-stack {
  width: 100%;
  max-width: 420px;
}

.adhoc-landing .nav-row-split {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.adhoc-landing .journey-family-pack-link {
  margin-top: 16px;
  text-align: center;
}

.adhoc-landing .journey-family-pack-link .btn-nav-offer {
  width: 100%;
  justify-content: center;
  text-decoration: none;
}

/* Family pack dedicated page */

.adhoc-landing .family-pack-page-main {
  padding: 48px 0 64px;
  background: var(--panel);
  border-top: 1px solid var(--line);
  min-height: calc(100dvh - 180px);
}

.adhoc-landing .family-pack-page-inner {
  max-width: 680px;
  margin: 0 auto;
}

.adhoc-landing .family-pack-page-inner h1 {
  font-family: var(--font-display);
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  line-height: 1.15;
  color: var(--ink);
  margin: 10px 0 12px;
}

.adhoc-landing .family-pack-page-lede {
  font-size: 16px;
  color: var(--muted);
  margin: 0 0 32px;
  max-width: 540px;
  line-height: 1.65;
}

.adhoc-landing .auth-google-btn {
  width: 100%;
  max-width: 420px;
  justify-content: center;
  margin-bottom: 16px;
}

.adhoc-landing .auth-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 420px;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 20px 22px;
  background: #fff;
}

.adhoc-landing .auth-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  text-align: left;
  width: 100%;
}

.adhoc-landing .auth-input {
  width: 100%;
  min-height: 44px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid var(--line);
  font-family: var(--font-body);
  font-size: 15px;
  color: var(--ink);
  background: #fff;
}

.adhoc-landing .auth-input:focus {
  outline: none;
  border-color: var(--teal);
  box-shadow: 0 0 0 3px rgba(63, 156, 140, 0.2);
}

.adhoc-landing .auth-submit-btn {
  width: 100%;
  justify-content: center;
  margin-top: 4px;
}

.adhoc-landing .family-pack-options {
  display: grid;
  gap: 12px;
}

.adhoc-landing .family-pack-option {
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid var(--line);
  color: var(--ink);
  font-family: var(--font-body);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.adhoc-landing .family-pack-option:hover:not(:disabled) {
  border-color: var(--teal);
  box-shadow: 0 8px 24px -12px rgba(63, 156, 140, 0.35);
}

.adhoc-landing .family-pack-option:disabled {
  opacity: 0.65;
  cursor: wait;
}

.adhoc-landing .family-pack-option-title {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 4px;
}

.adhoc-landing .family-pack-option-sub {
  display: block;
  font-size: 13.5px;
  color: var(--muted);
  font-weight: 400;
}

.adhoc-landing .family-pack-option-price {
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 700;
  color: var(--blue-deep);
  flex-shrink: 0;
}

.adhoc-landing .family-pack-custom {
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 20px 22px;
  background: #fff;
}

.adhoc-landing .family-pack-custom-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 14px;
  color: var(--ink);
}

.adhoc-landing .family-pack-custom-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.adhoc-landing .family-pack-custom-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--ink);
}

.adhoc-landing .family-pack-custom-input {
  width: 72px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--line);
  font-family: var(--font-body);
  font-size: 15px;
}

.adhoc-landing .family-pack-custom-price {
  font-family: var(--font-display);
  font-size: 18px;
  font-weight: 700;
  color: var(--blue-deep);
}

.adhoc-landing .family-pack-custom-hint {
  font-size: 13px;
  color: var(--muted);
  margin-top: 12px;
  margin-bottom: 0;
  text-align: center;
}

.adhoc-landing .family-pack-scan-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.adhoc-landing .family-pack-scan-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  width: 100%;
  text-align: center;
}

.adhoc-landing .scan-count-stepper {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid var(--line);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.adhoc-landing .scan-count-stepper-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  min-height: 44px;
  padding: 0;
  border: none;
  background: var(--panel);
  color: var(--ink);
  cursor: pointer;
  transition: background 0.15s ease;
}

.adhoc-landing .scan-count-stepper-btn:hover:not(:disabled) {
  background: #eef2f6;
}

.adhoc-landing .scan-count-stepper-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.adhoc-landing .scan-count-stepper-input {
  width: 56px;
  min-height: 44px;
  padding: 0 8px;
  border: none;
  border-left: 1px solid var(--line);
  border-right: 1px solid var(--line);
  font-family: var(--font-body);
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: var(--ink);
  background: #fff;
}

.adhoc-landing .scan-count-stepper-input:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px rgba(20, 184, 166, 0.35);
}

.adhoc-landing .family-pack-checkout-row {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.adhoc-landing .family-pack-checkout-options {
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.adhoc-landing .family-pack-checkout-btn {
  width: 100%;
  max-width: 300px;
  min-height: 52px;
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 999px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.adhoc-landing .family-pack-checkout-btn-inner {
  display: inline-block;
  white-space: nowrap;
}

.adhoc-landing .family-pack-pay-brand {
  font-weight: 700;
  letter-spacing: -0.03em;
}

.adhoc-landing .family-pack-checkout-btn-stripe {
  background: #635BFF;
  color: #fff;
  box-shadow: 0 8px 24px -6px rgba(99, 91, 255, 0.45);
}

.adhoc-landing .family-pack-checkout-btn-stripe:hover:not(:disabled) {
  background: #5851DF;
  box-shadow: 0 10px 28px -6px rgba(99, 91, 255, 0.5);
  transform: translateY(-1px);
}

.adhoc-landing .family-pack-checkout-btn-hitpay {
  background: #1B3A57;
  color: #fff;
  box-shadow: 0 8px 24px -6px rgba(27, 58, 87, 0.35);
}

.adhoc-landing .family-pack-checkout-btn-hitpay:hover:not(:disabled) {
  background: #152E45;
  box-shadow: 0 10px 28px -6px rgba(27, 58, 87, 0.45);
  transform: translateY(-1px);
}

.adhoc-landing .family-pack-nav-back {
  margin-left: auto;
}

.adhoc-landing .family-pack-error {
  color: #dc2626;
  margin-top: 20px;
  font-size: 14px;
}

/* Pack hub — owner share/copy + guest invite */

.adhoc-landing .journey-my-pack-link {
  width: 100%;
  justify-content: center;
  margin-top: 10px;
  text-decoration: none;
}

.adhoc-landing .btn-copy {
  flex-shrink: 0;
  background: var(--midnight);
  color: #fff;
  border: 1px solid var(--midnight);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 14px;
  white-space: nowrap;
}

.adhoc-landing .btn-copy:hover:not(:disabled) {
  background: var(--ink);
  border-color: var(--ink);
}

.adhoc-landing .pack-hub-share-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  align-items: stretch;
}

.adhoc-landing .pack-hub-share-input {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.adhoc-landing .pack-hub-share-row .btn-copy {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.adhoc-landing .pack-hub-start-btn {
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-bottom: 16px;
}

.adhoc-landing .pack-hub-page {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.adhoc-landing .pack-hub-page-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0 48px;
}

.adhoc-landing .pack-hub-card {
  max-width: 520px;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08);
}

.adhoc-landing .pack-hub-title {
  font-family: var(--font-display);
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  line-height: 1.15;
  color: var(--ink);
  margin: 10px 0 12px;
}

.adhoc-landing .pack-hub-lede {
  font-size: 16px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0 0 24px;
}

.adhoc-landing .pack-hub-credits {
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  text-align: center;
}

.adhoc-landing .pack-hub-credits-num {
  font-size: 36px;
  font-weight: 700;
  color: #0f766e;
  line-height: 1;
}

.adhoc-landing .pack-hub-credits-label {
  font-size: 14px;
  color: #0f766e;
  margin-top: 4px;
}

.adhoc-landing .pack-hub-guest-section {
  margin-bottom: 24px;
}

.adhoc-landing .pack-hub-guest-heading {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 16px;
  color: var(--ink);
  margin: 0 0 12px;
}

.adhoc-landing .pack-hub-guest-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.adhoc-landing .pack-hub-guest-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
}

.adhoc-landing .pack-hub-guest-list svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--teal);
}

.adhoc-landing .pack-hub-guest-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.adhoc-landing .pack-hub-guest-steps li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.adhoc-landing .pack-hub-guest-step-num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--panel);
  border: 1px solid var(--line);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  color: var(--teal);
}

.adhoc-landing .pack-hub-guest-steps h3 {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 16px;
  margin: 0 0 4px;
  color: var(--ink);
}

.adhoc-landing .pack-hub-guest-steps p {
  color: var(--muted);
  font-size: 14px;
  line-height: 1.55;
  margin: 0;
}

.adhoc-landing .pack-hub-share-heading {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
}

.adhoc-landing .pack-hub-fine {
  font-size: 13px;
  color: var(--muted);
  line-height: 1.5;
  margin: 0;
  text-align: center;
}

.adhoc-landing .pack-hub-depleted {
  text-align: center;
  margin-bottom: 0;
}

.adhoc-landing .pack-hub-guest-cta-wrap {
  margin-bottom: 28px;
}

.adhoc-landing .pack-hub-guest-cta-wrap .pack-hub-start-btn {
  margin-bottom: 0;
}

.adhoc-landing .pack-hub-guest-benefit-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.adhoc-landing .pack-hub-guest-benefit-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: 12px;
}

.adhoc-landing .pack-hub-guest-benefit-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ecfdf5;
  border: 1px solid #99f6e4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--teal);
}

.adhoc-landing .pack-hub-guest-benefit-title {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 15px;
  color: var(--ink);
  margin: 0 0 4px;
}

.adhoc-landing .pack-hub-guest-benefit-body {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

.adhoc-landing.pack-hub-page > footer {
  width: 100%;
  flex-shrink: 0;
  margin-top: auto;
}

@media (max-width: 880px) {
  .adhoc-landing .hero-grid {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    gap: 28px;
  }

  .adhoc-landing .hero-copy {
    grid-column: auto;
    grid-row: auto;
  }

  .adhoc-landing .phone-stage {
    grid-column: auto;
    grid-row: auto;
    align-self: auto;
  }

  .adhoc-landing .hero-cta-row {
    grid-column: auto;
    grid-row: auto;
    align-items: center;
  }

  .adhoc-landing .what-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .adhoc-landing .offers-bento {
    grid-template-columns: 1fr;
  }

  .adhoc-landing .offer-card {
    min-height: auto;
    padding: 24px;
  }

  .adhoc-landing .offer-card-heart,
  .adhoc-landing .offer-card-vitals {
    min-height: auto;
  }

  .adhoc-landing .how-rail-line {
    top: 0;
    bottom: 0;
    left: 25px;
    right: auto;
    width: 1px;
    height: auto;
    background: linear-gradient(
      180deg,
      transparent 0%,
      var(--panel-line) 6%,
      var(--teal) 50%,
      var(--panel-line) 94%,
      transparent 100%
    );
  }

  .adhoc-landing .how-steps {
    grid-template-columns: 1fr;
    gap: 36px;
    padding-left: 12px;
  }

  .adhoc-landing .how-step {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
    column-gap: 20px;
    row-gap: 6px;
    text-align: left;
    padding: 0 0 0 8px;
  }

  .adhoc-landing .how-step-marker {
    grid-row: 1 / span 2;
    margin-bottom: 0;
    align-self: start;
  }

  .adhoc-landing .how-step-index {
    display: none;
  }

  .adhoc-landing .how-step h3 {
    align-self: end;
    margin-bottom: 0;
  }

  .adhoc-landing .how-step p {
    max-width: none;
    margin: 0;
  }

  .adhoc-landing .science-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .adhoc-landing .science-media {
    min-height: 220px;
  }

  .adhoc-landing .journey-cta-wrap {
    padding: 0 20px;
  }

  .adhoc-landing .journey-card {
    padding: 32px 24px 28px;
    border-radius: 22px;
  }

  .adhoc-landing .journey-offer-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .adhoc-landing .journey-offer-box {
    text-align: center;
  }

  .adhoc-landing .facts {
    border-left: none;
    padding-left: 0;
  }

  .adhoc-landing .fact::before {
    left: 0;
  }

  .adhoc-landing .fact {
    padding-left: 24px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .adhoc-landing .glow,
  .adhoc-landing .scan-line,
  .adhoc-landing .wave,
  .adhoc-landing .science-wave {
    animation: none !important;
  }

  .adhoc-landing .science-wave {
    stroke-dashoffset: 0;
  }

  .adhoc-landing .scan-line {
    transform: translateY(160px);
  }

  .adhoc-landing .wave {
    stroke-dashoffset: 0;
  }
}

.adhoc-landing .flow-privacy-note,
.adhoc-landing .auth-legal-note {
  margin: 16px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: #64748b;
  text-align: center;
}

.adhoc-landing .privacy-inline-link {
  color: #12a594;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.adhoc-landing .privacy-inline-link:hover {
  color: #0b3b4f;
}
`, "",{"version":3,"sources":["webpack://./src/components/adhoc/landing.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gCAAgC;EAChC,uCAAuC;EACvC,mFAAmF;;EAEnF,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uDAAuD;EACvD,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,iCAAiC;EACjC,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8EAA8E;EAC9E,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,sBAAsB,EAAE;AAC5C;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,KAAK,0BAA0B,EAAE,YAAY,EAAE;EAC/C,OAAO,4BAA4B,EAAE,YAAY,EAAE;AACrD;;AAEA;EACE,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,KAAK,sBAAsB,EAAE;EAC7B,OAAO,oBAAoB,EAAE;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,WAAW;EACX;;;;;;;GAOC;EACD,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB;;0CAEwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB;;6BAE2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C;;2CAEyC;EACzC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO,qBAAqB,EAAE;EAC9B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;wCAEsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB;;0CAEwC;EACxC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,+CAA+C;EAC/C,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,+BAA+B;;AAE/B;EACE,oBAAoB;EACpB,wBAAwB;EACxB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+CAA+C;;AAE/C;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ;;;;;;;KAOC;EACH;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".adhoc-landing {\n  --bg: #FFFFFF;\n  --panel: #F3F9F8;\n  --panel-line: #E2EAE8;\n  --blue: #1B6FAE;\n  --blue-deep: #0E4E80;\n  --teal: #3F9C8C;\n  --green: #5DA73D;\n  --green-deep: #3F7A2A;\n  --ink: #152631;\n  --midnight: #0B141B;\n  --muted: #56666E;\n  --line: #E3E9E8;\n  --font-display: 'Bricolage Grotesque', sans-serif;\n  --font-body: 'Inter', sans-serif;\n  --font-mono: 'IBM Plex Mono', monospace;\n  --grad: linear-gradient(135deg, var(--blue) 0%, var(--teal) 55%, var(--green) 100%);\n\n  background: var(--bg);\n  color: var(--ink);\n  font-family: var(--font-body);\n  line-height: 1.6;\n  overflow-x: hidden;\n  overflow-y: visible;\n  min-height: 100%;\n  position: relative;\n}\n\n.adhoc-landing * {\n  box-sizing: border-box;\n}\n\n.adhoc-landing .wrap {\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 0 32px;\n}\n\n.adhoc-landing .eyebrow {\n  font-family: var(--font-mono);\n  font-size: 12.5px;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: var(--teal);\n  font-weight: 500;\n}\n\n.adhoc-landing .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 15px;\n  color: #fff;\n  background: var(--grad);\n  border: none;\n  padding: 14px 26px;\n  border-radius: 9px;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  text-decoration: none;\n}\n\n.adhoc-landing .btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 22px -8px rgba(27, 111, 174, 0.45);\n}\n\n.adhoc-landing .btn:focus-visible {\n  outline: 2px solid var(--blue-deep);\n  outline-offset: 3px;\n}\n\n.adhoc-landing .btn:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.adhoc-landing .btn .pulse-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #fff;\n  display: inline-block;\n}\n\n.adhoc-landing .btn-ghost {\n  background: transparent;\n  color: var(--ink);\n  border: 1px solid var(--line);\n  padding: 10px 18px;\n  font-size: 14px;\n}\n\n.adhoc-landing .btn-ghost:hover:not(:disabled) {\n  border-color: var(--teal);\n  box-shadow: none;\n  transform: none;\n}\n\n.adhoc-landing .price-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  font-family: var(--font-mono);\n  font-size: 13.5px;\n}\n\n.adhoc-landing .price-chip .was {\n  color: var(--muted);\n  text-decoration: line-through;\n}\n\n.adhoc-landing .price-chip .now {\n  color: var(--green-deep);\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.adhoc-landing .price-chip .off {\n  background: #EAF4E5;\n  color: var(--green-deep);\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  padding: 3px 8px;\n  border-radius: 5px;\n}\n\n.adhoc-landing .price-chip .off-promo {\n  background: #FEE2E2;\n  color: #B91C1C;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 4px 10px;\n  border-radius: 6px;\n  text-transform: uppercase;\n}\n\n.adhoc-landing .price-chip .usual {\n  color: var(--muted);\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.adhoc-landing .cta-offer-stack {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.adhoc-landing .cta-offer-stack-center {\n  align-items: center;\n}\n\n.adhoc-landing .cta-primary-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.adhoc-landing .cta-primary-wrap .btn-offer,\n.adhoc-landing .cta-primary-wrap .btn-journey {\n  width: 100%;\n  max-width: 420px;\n  justify-content: center;\n}\n\n.adhoc-landing .scan-credits-remaining {\n  margin: 0;\n  font-size: 13px;\n  color: var(--muted);\n  text-align: center;\n}\n\n.adhoc-landing .nav-credits-continue {\n  white-space: nowrap;\n}\n\n.adhoc-landing .btn-offer {\n  background: #2D6A4F;\n  border-radius: 999px;\n  font-size: 16px;\n  font-weight: 700;\n  padding: 16px 28px;\n  box-shadow: 0 8px 24px -6px rgba(45, 106, 79, 0.45);\n  white-space: nowrap;\n}\n\n.adhoc-landing .btn-offer:hover:not(:disabled) {\n  background: #40916C;\n  box-shadow: 0 10px 28px -6px rgba(45, 106, 79, 0.5);\n}\n\n.adhoc-landing .btn-offer .btn-arrow {\n  font-size: 18px;\n  line-height: 1;\n  margin-left: 2px;\n}\n\n.adhoc-landing .btn-nav-offer {\n  font-size: 13px;\n  padding: 10px 18px;\n  white-space: nowrap;\n  background: var(--midnight);\n  color: #fff;\n  border: 1px solid var(--midnight);\n  border-radius: 999px;\n  box-shadow: 0 6px 18px -8px rgba(11, 20, 27, 0.45);\n}\n\n.adhoc-landing .btn-nav-offer:hover:not(:disabled) {\n  background: var(--ink);\n  border-color: var(--ink);\n  box-shadow: 0 8px 22px -8px rgba(11, 20, 27, 0.5);\n  transform: translateY(-1px);\n}\n\n.adhoc-landing nav {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid var(--line);\n}\n\n.adhoc-landing nav .wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 96px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.adhoc-landing .nav-logo img {\n  height: 58px;\n  width: auto;\n  display: block;\n  object-fit: contain;\n}\n\n.adhoc-landing .hero {\n  position: relative;\n  padding: 88px 0 110px;\n  overflow: hidden;\n}\n\n.adhoc-landing .glow {\n  position: absolute;\n  top: -180px;\n  right: -220px;\n  width: 620px;\n  height: 620px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(63, 156, 140, 0.10), transparent 70%);\n  animation: adhoc-breathe 6s ease-in-out infinite;\n  pointer-events: none;\n}\n\n@keyframes adhoc-breathe {\n  0%, 100% { opacity: 0.7; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.07); }\n}\n\n.adhoc-landing .hero-grid {\n  display: grid;\n  grid-template-columns: 1.05fr 0.95fr;\n  grid-template-rows: auto auto;\n  gap: 32px 56px;\n  align-items: start;\n  position: relative;\n  z-index: 1;\n}\n\n.adhoc-landing .hero-copy {\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.adhoc-landing .hero h1 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(2.3rem, 4.4vw, 4rem);\n  line-height: 1.07;\n  letter-spacing: -0.01em;\n  margin: 16px 0 22px;\n}\n\n.adhoc-landing .hero h1 em {\n  font-style: normal;\n  color: var(--green-deep);\n}\n\n.adhoc-landing .hero p.lede {\n  font-size: 17.5px;\n  color: var(--muted);\n  max-width: 480px;\n  margin-bottom: 0;\n}\n\n.adhoc-landing .hero-cta-row {\n  grid-column: 1;\n  grid-row: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 0;\n}\n\n.adhoc-landing .phone-stage {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  display: flex;\n  justify-content: center;\n  align-self: center;\n}\n\n.adhoc-landing .phone {\n  width: 280px;\n  background: #0E1A22;\n  border: 6px solid #ECF1F0;\n  border-radius: 36px;\n  padding: 10px;\n  box-shadow: 0 30px 60px -28px rgba(16, 40, 50, 0.35);\n}\n\n.adhoc-landing .screen {\n  position: relative;\n  background: var(--midnight);\n  border-radius: 26px;\n  overflow: hidden;\n  height: 380px;\n}\n\n.adhoc-landing .scan-svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.adhoc-landing .scan-line {\n  animation: adhoc-sweep 4s ease-in-out infinite alternate;\n}\n\n@keyframes adhoc-sweep {\n  0% { transform: translateY(8px); opacity: 0.9; }\n  100% { transform: translateY(312px); opacity: 0.9; }\n}\n\n.adhoc-landing .wave {\n  stroke-dasharray: 560;\n  animation: adhoc-draw 4s ease-in-out infinite alternate;\n}\n\n@keyframes adhoc-draw {\n  0% { stroke-dashoffset: 560; }\n  100% { stroke-dashoffset: 0; }\n}\n\n.adhoc-landing .readouts {\n  position: absolute;\n  bottom: 14px;\n  left: 14px;\n  right: 14px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.adhoc-landing .readout {\n  font-family: var(--font-mono);\n}\n\n.adhoc-landing .readout .num {\n  font-size: 21px;\n  font-weight: 500;\n  color: #F4FAF8;\n  display: block;\n}\n\n.adhoc-landing .readout .lbl {\n  font-size: 10.5px;\n  color: #7FE0C4;\n  letter-spacing: 0.06em;\n}\n\n.adhoc-landing .section {\n  padding: 90px 0;\n}\n\n.adhoc-landing .what-is {\n  border-top: 1px solid var(--line);\n}\n\n.adhoc-landing .offers-section {\n  border-top: 1px solid var(--line);\n}\n\n.adhoc-landing .offers-head {\n  text-align: center;\n  max-width: 640px;\n  margin: 0 auto 48px;\n}\n\n.adhoc-landing .offers-head h2 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(1.8rem, 3vw, 2.5rem);\n  line-height: 1.14;\n  margin: 14px 0 14px;\n}\n\n.adhoc-landing .offers-head p {\n  color: var(--muted);\n  font-size: 16.5px;\n}\n\n.adhoc-landing .offers-bento {\n  display: grid;\n  grid-template-columns: 1.65fr 1fr;\n  gap: 20px;\n}\n\n.adhoc-landing .offer-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: 18px;\n  padding: 28px 32px 32px;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n}\n\n.adhoc-landing .offer-card-light {\n  background: #fff;\n  border: 1px solid var(--panel-line);\n}\n\n.adhoc-landing .offer-card-dark {\n  background: var(--ink);\n  border: 1px solid var(--ink);\n  color: #fff;\n}\n\n.adhoc-landing .offer-card-dark p {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.adhoc-landing .offer-card-accent {\n  background: #EAF4E5;\n  border: 1px solid #C8E6C0;\n}\n\n.adhoc-landing .offer-card-accent h3 {\n  color: var(--green-deep);\n}\n\n.adhoc-landing .offer-card-accent p {\n  color: #3D5C35;\n  max-width: 420px;\n}\n\n.adhoc-landing .offer-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.adhoc-landing .offer-icon-rose {\n  background: #FEE2E2;\n  color: #DC2626;\n}\n\n.adhoc-landing .offer-icon-sky {\n  background: rgba(255, 255, 255, 0.12);\n  color: #7DD3FC;\n}\n\n.adhoc-landing .offer-icon-blue {\n  background: #DBEAFE;\n  color: var(--blue);\n}\n\n.adhoc-landing .offer-icon-green {\n  background: rgba(93, 167, 61, 0.18);\n  color: var(--green-deep);\n}\n\n.adhoc-landing .offer-card h3 {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 17px;\n  margin: 0 0 10px;\n  line-height: 1.3;\n}\n\n.adhoc-landing .offer-card-dark h3 {\n  color: #fff;\n}\n\n.adhoc-landing .offer-card p {\n  color: var(--muted);\n  font-size: 14.5px;\n  line-height: 1.55;\n  margin: 0;\n  flex: 1;\n  max-width: 92%;\n}\n\n.adhoc-landing .offer-card-heart {\n  min-height: 280px;\n}\n\n.adhoc-landing .offer-chart {\n  display: block;\n  width: 100%;\n  max-width: 340px;\n  height: auto;\n  margin-top: 20px;\n  opacity: 0.95;\n}\n\n.adhoc-landing .offer-card-vitals {\n  min-height: 280px;\n}\n\n.adhoc-landing .offer-accent-ring {\n  position: absolute;\n  right: -40px;\n  bottom: -40px;\n  width: 180px;\n  height: 180px;\n  border-radius: 50%;\n  border: 28px solid rgba(93, 167, 61, 0.12);\n  pointer-events: none;\n}\n\n.adhoc-landing .how-section {\n  border-top: 1px solid var(--line);\n  background: var(--panel);\n}\n\n.adhoc-landing .how-head {\n  text-align: center;\n  max-width: 560px;\n  margin: 0 auto 56px;\n}\n\n.adhoc-landing .how-head h2 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(1.8rem, 3vw, 2.5rem);\n  line-height: 1.14;\n  margin: 14px 0 14px;\n}\n\n.adhoc-landing .how-head p {\n  color: var(--muted);\n  font-size: 16.5px;\n}\n\n.adhoc-landing .how-rail {\n  position: relative;\n}\n\n.adhoc-landing .how-rail-line {\n  position: absolute;\n  top: 34px;\n  left: 8%;\n  right: 8%;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    var(--panel-line) 8%,\n    var(--teal) 50%,\n    var(--panel-line) 92%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n.adhoc-landing .how-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 28px;\n  align-items: start;\n}\n\n.adhoc-landing .how-step {\n  position: relative;\n  text-align: center;\n  padding: 0 8px;\n}\n\n.adhoc-landing .how-step-marker {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 22px;\n}\n\n.adhoc-landing .how-step-index {\n  font-family: var(--font-mono);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  color: var(--green-deep);\n  background: #fff;\n  border: 1px solid var(--panel-line);\n  border-radius: 6px;\n  padding: 4px 10px;\n  line-height: 1;\n  box-shadow: 0 1px 0 rgba(21, 38, 49, 0.04);\n}\n\n.adhoc-landing .how-step-icon-wrap {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid var(--panel-line);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--blue-deep);\n  position: relative;\n  box-shadow:\n    0 1px 2px rgba(21, 38, 49, 0.05),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.adhoc-landing .how-step-icon-wrap::before {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  border-radius: inherit;\n  padding: 1px;\n  background: var(--grad);\n  -webkit-mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.adhoc-landing .how-step h3 {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 16px;\n  margin: 0 0 8px;\n  color: var(--ink);\n}\n\n.adhoc-landing .how-step p {\n  color: var(--muted);\n  font-size: 14px;\n  line-height: 1.55;\n  margin: 0 auto;\n  max-width: 220px;\n}\n\n.adhoc-landing .what-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 64px;\n}\n\n.adhoc-landing .what-grid h2 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(1.8rem, 3vw, 2.5rem);\n  line-height: 1.14;\n  margin: 14px 0 18px;\n  max-width: 420px;\n}\n\n.adhoc-landing .what-grid .copy {\n  color: var(--muted);\n  font-size: 16.5px;\n  max-width: 440px;\n}\n\n.adhoc-landing .facts {\n  border-left: 1px solid var(--line);\n  padding-left: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.adhoc-landing .fact {\n  position: relative;\n}\n\n.adhoc-landing .fact::before {\n  content: '';\n  position: absolute;\n  left: -41px;\n  top: 7px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--teal);\n}\n\n.adhoc-landing .fact h3 {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.adhoc-landing .fact p {\n  color: var(--muted);\n  font-size: 14.5px;\n}\n\n.adhoc-landing .science-section {\n  background: var(--ink);\n  color: #fff;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.adhoc-landing .science-grid {\n  display: grid;\n  grid-template-columns: 1.05fr 1fr;\n  gap: 56px;\n  align-items: center;\n}\n\n.adhoc-landing .science-media {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid rgba(127, 224, 196, 0.14);\n  box-shadow:\n    0 24px 48px -24px rgba(0, 0, 0, 0.65),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  aspect-ratio: 16 / 10;\n  min-height: 280px;\n}\n\n.adhoc-landing .science-media-svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.adhoc-landing .science-wave {\n  stroke-dasharray: 720;\n  animation: science-wave-draw 4.5s ease-in-out infinite alternate;\n}\n\n.adhoc-landing .science-wave-dim {\n  animation-delay: 0.6s;\n}\n\n@keyframes science-wave-draw {\n  from { stroke-dashoffset: 80; }\n  to { stroke-dashoffset: 0; }\n}\n\n.adhoc-landing .science-play {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: var(--green);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow:\n    0 0 0 10px rgba(93, 167, 61, 0.18),\n    0 16px 32px -8px rgba(0, 0, 0, 0.45);\n  pointer-events: none;\n}\n\n.adhoc-landing .science-play svg {\n  margin-left: 3px;\n}\n\n.adhoc-landing .eyebrow-light {\n  color: #7FE0C4;\n}\n\n.adhoc-landing .science-copy h2 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(1.75rem, 3vw, 2.35rem);\n  line-height: 1.18;\n  margin: 14px 0 18px;\n  max-width: 480px;\n}\n\n.adhoc-landing .science-accent {\n  color: var(--green);\n}\n\n.adhoc-landing .science-lede {\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 16px;\n  line-height: 1.65;\n  max-width: 520px;\n  margin: 0 0 28px;\n}\n\n.adhoc-landing .science-points {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.adhoc-landing .science-points li {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 15px;\n  line-height: 1.55;\n}\n\n.adhoc-landing .science-points strong {\n  color: #fff;\n  font-weight: 600;\n}\n\n.adhoc-landing .science-check {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 7px;\n  background: var(--green);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1px;\n  box-shadow: 0 4px 12px -4px rgba(93, 167, 61, 0.55);\n}\n\n.adhoc-landing .report-section {\n  background: var(--panel);\n  border-top: 1px solid var(--line);\n  border-bottom: 1px solid var(--line);\n}\n\n.adhoc-landing .report-head {\n  max-width: 560px;\n  margin-bottom: 46px;\n}\n\n.adhoc-landing .report-head h2 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(1.8rem, 3vw, 2.5rem);\n  line-height: 1.14;\n  margin: 14px 0 14px;\n}\n\n.adhoc-landing .report-head p {\n  color: var(--muted);\n  font-size: 16.5px;\n}\n\n.adhoc-landing .report-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 18px;\n}\n\n.adhoc-landing .rcard {\n  background: #fff;\n  border: 1px solid var(--panel-line);\n  border-radius: 14px;\n  padding: 22px 22px 20px;\n}\n\n.adhoc-landing .rcard .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.adhoc-landing .rcard .cat {\n  font-family: var(--font-mono);\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--muted);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.adhoc-landing .rcard .metric {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: 7px 0;\n  border-top: 1px solid var(--panel-line);\n}\n\n.adhoc-landing .rcard .metric:first-of-type {\n  border-top: none;\n}\n\n.adhoc-landing .rcard .metric .name {\n  font-size: 13.5px;\n  color: var(--muted);\n}\n\n.adhoc-landing .rcard .metric .val {\n  font-family: var(--font-mono);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--ink);\n}\n\n.adhoc-landing .journey-cta-section {\n  background: var(--panel);\n  border-top: 1px solid var(--line);\n  padding: 64px 0 72px;\n  display: flex;\n  justify-content: center;\n}\n\n.adhoc-landing .journey-cta-wrap {\n  width: 100%;\n  max-width: 680px;\n  margin: 0 auto;\n  padding: 0 32px;\n  display: flex;\n  justify-content: center;\n}\n\n.adhoc-landing .journey-card {\n  width: 100%;\n  max-width: 620px;\n  margin: 0;\n  background: #fff;\n  border: 1px solid var(--panel-line);\n  border-radius: 28px;\n  padding: 44px 44px 36px;\n  box-shadow:\n    0 24px 48px -28px rgba(21, 38, 49, 0.18),\n    0 1px 0 rgba(255, 255, 255, 0.9) inset;\n  text-align: center;\n  overflow: visible;\n}\n\n.adhoc-landing .journey-card-head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.adhoc-landing .journey-card-head h2 {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: clamp(1.55rem, 3vw, 2rem);\n  line-height: 1.2;\n  margin: 0;\n  color: var(--ink);\n}\n\n.adhoc-landing .journey-card-subhead {\n  display: block;\n  color: var(--muted);\n  font-size: 16px;\n  line-height: 1.55;\n  margin: 0;\n  max-width: 460px;\n}\n\n.adhoc-landing .journey-offer-box {\n  background: var(--panel);\n  border: 1px solid var(--panel-line);\n  border-radius: 16px;\n  padding: 20px 22px;\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.adhoc-landing .journey-offer-label {\n  display: block;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--green-deep);\n  margin-bottom: 14px;\n}\n\n.adhoc-landing .journey-offer-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.adhoc-landing .journey-offer-price {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 18px;\n  color: var(--ink);\n  margin: 0 0 4px;\n}\n\n.adhoc-landing .journey-offer-was {\n  color: var(--muted);\n  font-size: 14px;\n  margin: 0;\n}\n\n.adhoc-landing .journey-save-badge {\n  flex-shrink: 0;\n  background: #EAF4E5;\n  color: var(--green-deep);\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 13px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.adhoc-landing .btn-journey {\n  width: 100%;\n  justify-content: center;\n  background: var(--green-deep);\n  border-radius: 999px;\n  font-size: 16px;\n  font-weight: 700;\n  padding: 17px 28px;\n  box-shadow: 0 10px 28px -8px rgba(63, 122, 42, 0.45);\n}\n\n.adhoc-landing .btn-journey:hover:not(:disabled) {\n  background: #4A8F32;\n  box-shadow: 0 12px 32px -8px rgba(63, 122, 42, 0.5);\n  transform: translateY(-1px);\n}\n\n.adhoc-landing .journey-card-cta {\n  width: 100%;\n}\n\n.adhoc-landing .journey-card-cta .btn-nav-offer {\n  width: 100%;\n  justify-content: center;\n  font-size: 16px;\n  padding: 14px 28px;\n}\n\n.adhoc-landing .hero-cta-row .cta-offer-stack .btn-nav-offer {\n  width: 100%;\n  justify-content: center;\n  font-size: 16px;\n  padding: 14px 28px;\n}\n\n.adhoc-landing .journey-fine {\n  margin: 18px 0 0;\n  color: var(--muted);\n  font-size: 13px;\n  line-height: 1.5;\n  text-align: center;\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.adhoc-landing footer {\n  background: var(--ink);\n  color: #fff;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 30px 0 48px;\n  margin-bottom: env(safe-area-inset-bottom, 0);\n}\n\n.adhoc-landing footer .wrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.adhoc-landing footer .brand {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.adhoc-landing footer .brand img {\n  height: 38px;\n  width: auto;\n  display: block;\n  object-fit: contain;\n}\n\n.adhoc-landing footer .brand span {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 17px;\n  color: #fff;\n}\n\n.adhoc-landing footer .fine {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.72);\n  max-width: 480px;\n}\n\n.adhoc-landing .pay-error {\n  margin: 0 32px 16px;\n  max-width: 1180px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 14px 18px;\n  background: #FEF2F2;\n  border: 1px solid #FECACA;\n  border-radius: 10px;\n  color: #B91C1C;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.adhoc-landing .pay-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  background: rgba(255, 255, 255, 0.88);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.adhoc-landing .pay-overlay-spinner {\n  width: 44px;\n  height: 44px;\n  border: 4px solid rgba(27, 111, 174, 0.15);\n  border-top-color: var(--blue);\n  border-radius: 50%;\n  animation: adhoc-spin 0.8s linear infinite;\n}\n\n@keyframes adhoc-spin {\n  to { transform: rotate(360deg); }\n}\n\n.adhoc-landing .pay-overlay p {\n  color: var(--muted);\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.adhoc-landing .family-pack-buy-single {\n  margin-top: 8px;\n}\n\n.adhoc-landing .journey-family-pack-link-compact {\n  margin-top: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.adhoc-landing .hero-cta-row .journey-family-pack-link {\n  margin-top: 4px;\n  width: 100%;\n  max-width: 420px;\n}\n\n.adhoc-landing .scan-credits-cta {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.adhoc-landing .scan-credits-btn {\n  width: 100%;\n  max-width: 300px;\n  justify-content: center;\n  text-align: center;\n}\n\n.adhoc-landing .scan-credits-remaining {\n  margin: 0;\n  font-size: 13px;\n  color: var(--muted);\n  text-align: center;\n}\n\n.adhoc-landing .hero-cta-row .scan-credits-cta {\n  width: 100%;\n  max-width: 420px;\n}\n\n.adhoc-landing .hero-cta-row .cta-offer-stack {\n  width: 100%;\n  max-width: 420px;\n}\n\n.adhoc-landing .nav-row-split {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n}\n\n.adhoc-landing .journey-family-pack-link {\n  margin-top: 16px;\n  text-align: center;\n}\n\n.adhoc-landing .journey-family-pack-link .btn-nav-offer {\n  width: 100%;\n  justify-content: center;\n  text-decoration: none;\n}\n\n/* Family pack dedicated page */\n\n.adhoc-landing .family-pack-page-main {\n  padding: 48px 0 64px;\n  background: var(--panel);\n  border-top: 1px solid var(--line);\n  min-height: calc(100dvh - 180px);\n}\n\n.adhoc-landing .family-pack-page-inner {\n  max-width: 680px;\n  margin: 0 auto;\n}\n\n.adhoc-landing .family-pack-page-inner h1 {\n  font-family: var(--font-display);\n  font-size: clamp(28px, 4vw, 36px);\n  font-weight: 700;\n  line-height: 1.15;\n  color: var(--ink);\n  margin: 10px 0 12px;\n}\n\n.adhoc-landing .family-pack-page-lede {\n  font-size: 16px;\n  color: var(--muted);\n  margin: 0 0 32px;\n  max-width: 540px;\n  line-height: 1.65;\n}\n\n.adhoc-landing .auth-google-btn {\n  width: 100%;\n  max-width: 420px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.adhoc-landing .auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 420px;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 20px 22px;\n  background: #fff;\n}\n\n.adhoc-landing .auth-field {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink);\n  text-align: left;\n  width: 100%;\n}\n\n.adhoc-landing .auth-input {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid var(--line);\n  font-family: var(--font-body);\n  font-size: 15px;\n  color: var(--ink);\n  background: #fff;\n}\n\n.adhoc-landing .auth-input:focus {\n  outline: none;\n  border-color: var(--teal);\n  box-shadow: 0 0 0 3px rgba(63, 156, 140, 0.2);\n}\n\n.adhoc-landing .auth-submit-btn {\n  width: 100%;\n  justify-content: center;\n  margin-top: 4px;\n}\n\n.adhoc-landing .family-pack-options {\n  display: grid;\n  gap: 12px;\n}\n\n.adhoc-landing .family-pack-option {\n  width: 100%;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 22px;\n  border-radius: 12px;\n  background: #fff;\n  border: 1px solid var(--line);\n  color: var(--ink);\n  font-family: var(--font-body);\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.adhoc-landing .family-pack-option:hover:not(:disabled) {\n  border-color: var(--teal);\n  box-shadow: 0 8px 24px -12px rgba(63, 156, 140, 0.35);\n}\n\n.adhoc-landing .family-pack-option:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.adhoc-landing .family-pack-option-title {\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--ink);\n  margin-bottom: 4px;\n}\n\n.adhoc-landing .family-pack-option-sub {\n  display: block;\n  font-size: 13.5px;\n  color: var(--muted);\n  font-weight: 400;\n}\n\n.adhoc-landing .family-pack-option-price {\n  font-family: var(--font-display);\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--blue-deep);\n  flex-shrink: 0;\n}\n\n.adhoc-landing .family-pack-custom {\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 20px 22px;\n  background: #fff;\n}\n\n.adhoc-landing .family-pack-custom-title {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 14px;\n  color: var(--ink);\n}\n\n.adhoc-landing .family-pack-custom-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.adhoc-landing .family-pack-custom-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--ink);\n}\n\n.adhoc-landing .family-pack-custom-input {\n  width: 72px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--line);\n  font-family: var(--font-body);\n  font-size: 15px;\n}\n\n.adhoc-landing .family-pack-custom-price {\n  font-family: var(--font-display);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--blue-deep);\n}\n\n.adhoc-landing .family-pack-custom-hint {\n  font-size: 13px;\n  color: var(--muted);\n  margin-top: 12px;\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.adhoc-landing .family-pack-scan-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.adhoc-landing .family-pack-scan-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink);\n  width: 100%;\n  text-align: center;\n}\n\n.adhoc-landing .scan-count-stepper {\n  display: inline-flex;\n  align-items: stretch;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.adhoc-landing .scan-count-stepper-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  min-height: 44px;\n  padding: 0;\n  border: none;\n  background: var(--panel);\n  color: var(--ink);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.adhoc-landing .scan-count-stepper-btn:hover:not(:disabled) {\n  background: #eef2f6;\n}\n\n.adhoc-landing .scan-count-stepper-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.adhoc-landing .scan-count-stepper-input {\n  width: 56px;\n  min-height: 44px;\n  padding: 0 8px;\n  border: none;\n  border-left: 1px solid var(--line);\n  border-right: 1px solid var(--line);\n  font-family: var(--font-body);\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  color: var(--ink);\n  background: #fff;\n}\n\n.adhoc-landing .scan-count-stepper-input:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 2px rgba(20, 184, 166, 0.35);\n}\n\n.adhoc-landing .family-pack-checkout-row {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.adhoc-landing .family-pack-checkout-options {\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.adhoc-landing .family-pack-checkout-btn {\n  width: 100%;\n  max-width: 300px;\n  min-height: 52px;\n  padding: 14px 20px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 999px;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.adhoc-landing .family-pack-checkout-btn-inner {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.adhoc-landing .family-pack-pay-brand {\n  font-weight: 700;\n  letter-spacing: -0.03em;\n}\n\n.adhoc-landing .family-pack-checkout-btn-stripe {\n  background: #635BFF;\n  color: #fff;\n  box-shadow: 0 8px 24px -6px rgba(99, 91, 255, 0.45);\n}\n\n.adhoc-landing .family-pack-checkout-btn-stripe:hover:not(:disabled) {\n  background: #5851DF;\n  box-shadow: 0 10px 28px -6px rgba(99, 91, 255, 0.5);\n  transform: translateY(-1px);\n}\n\n.adhoc-landing .family-pack-checkout-btn-hitpay {\n  background: #1B3A57;\n  color: #fff;\n  box-shadow: 0 8px 24px -6px rgba(27, 58, 87, 0.35);\n}\n\n.adhoc-landing .family-pack-checkout-btn-hitpay:hover:not(:disabled) {\n  background: #152E45;\n  box-shadow: 0 10px 28px -6px rgba(27, 58, 87, 0.45);\n  transform: translateY(-1px);\n}\n\n.adhoc-landing .family-pack-nav-back {\n  margin-left: auto;\n}\n\n.adhoc-landing .family-pack-error {\n  color: #dc2626;\n  margin-top: 20px;\n  font-size: 14px;\n}\n\n/* Pack hub — owner share/copy + guest invite */\n\n.adhoc-landing .journey-my-pack-link {\n  width: 100%;\n  justify-content: center;\n  margin-top: 10px;\n  text-decoration: none;\n}\n\n.adhoc-landing .btn-copy {\n  flex-shrink: 0;\n  background: var(--midnight);\n  color: #fff;\n  border: 1px solid var(--midnight);\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 14px;\n  white-space: nowrap;\n}\n\n.adhoc-landing .btn-copy:hover:not(:disabled) {\n  background: var(--ink);\n  border-color: var(--ink);\n}\n\n.adhoc-landing .pack-hub-share-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  align-items: stretch;\n}\n\n.adhoc-landing .pack-hub-share-input {\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.adhoc-landing .pack-hub-share-row .btn-copy {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.adhoc-landing .pack-hub-start-btn {\n  width: 100%;\n  justify-content: center;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.adhoc-landing .pack-hub-page {\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n}\n\n.adhoc-landing .pack-hub-page-main {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 0 48px;\n}\n\n.adhoc-landing .pack-hub-card {\n  max-width: 520px;\n  width: 100%;\n  background: #fff;\n  border-radius: 16px;\n  padding: 32px 28px;\n  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08);\n}\n\n.adhoc-landing .pack-hub-title {\n  font-family: var(--font-display);\n  font-size: clamp(28px, 4vw, 36px);\n  font-weight: 700;\n  line-height: 1.15;\n  color: var(--ink);\n  margin: 10px 0 12px;\n}\n\n.adhoc-landing .pack-hub-lede {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0 0 24px;\n}\n\n.adhoc-landing .pack-hub-credits {\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.adhoc-landing .pack-hub-credits-num {\n  font-size: 36px;\n  font-weight: 700;\n  color: #0f766e;\n  line-height: 1;\n}\n\n.adhoc-landing .pack-hub-credits-label {\n  font-size: 14px;\n  color: #0f766e;\n  margin-top: 4px;\n}\n\n.adhoc-landing .pack-hub-guest-section {\n  margin-bottom: 24px;\n}\n\n.adhoc-landing .pack-hub-guest-heading {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--ink);\n  margin: 0 0 12px;\n}\n\n.adhoc-landing .pack-hub-guest-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.adhoc-landing .pack-hub-guest-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n}\n\n.adhoc-landing .pack-hub-guest-list svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--teal);\n}\n\n.adhoc-landing .pack-hub-guest-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.adhoc-landing .pack-hub-guest-steps li {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.adhoc-landing .pack-hub-guest-step-num {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--panel);\n  border: 1px solid var(--line);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-mono);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--teal);\n}\n\n.adhoc-landing .pack-hub-guest-steps h3 {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 16px;\n  margin: 0 0 4px;\n  color: var(--ink);\n}\n\n.adhoc-landing .pack-hub-guest-steps p {\n  color: var(--muted);\n  font-size: 14px;\n  line-height: 1.55;\n  margin: 0;\n}\n\n.adhoc-landing .pack-hub-share-heading {\n  margin-bottom: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.adhoc-landing .pack-hub-fine {\n  font-size: 13px;\n  color: var(--muted);\n  line-height: 1.5;\n  margin: 0;\n  text-align: center;\n}\n\n.adhoc-landing .pack-hub-depleted {\n  text-align: center;\n  margin-bottom: 0;\n}\n\n.adhoc-landing .pack-hub-guest-cta-wrap {\n  margin-bottom: 28px;\n}\n\n.adhoc-landing .pack-hub-guest-cta-wrap .pack-hub-start-btn {\n  margin-bottom: 0;\n}\n\n.adhoc-landing .pack-hub-guest-benefit-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.adhoc-landing .pack-hub-guest-benefit-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 18px;\n  background: var(--panel);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n}\n\n.adhoc-landing .pack-hub-guest-benefit-icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #ecfdf5;\n  border: 1px solid #99f6e4;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--teal);\n}\n\n.adhoc-landing .pack-hub-guest-benefit-title {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 15px;\n  color: var(--ink);\n  margin: 0 0 4px;\n}\n\n.adhoc-landing .pack-hub-guest-benefit-body {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n.adhoc-landing.pack-hub-page > footer {\n  width: 100%;\n  flex-shrink: 0;\n  margin-top: auto;\n}\n\n@media (max-width: 880px) {\n  .adhoc-landing .hero-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: none;\n    gap: 28px;\n  }\n\n  .adhoc-landing .hero-copy {\n    grid-column: auto;\n    grid-row: auto;\n  }\n\n  .adhoc-landing .phone-stage {\n    grid-column: auto;\n    grid-row: auto;\n    align-self: auto;\n  }\n\n  .adhoc-landing .hero-cta-row {\n    grid-column: auto;\n    grid-row: auto;\n    align-items: center;\n  }\n\n  .adhoc-landing .what-grid {\n    grid-template-columns: 1fr;\n    gap: 36px;\n  }\n\n  .adhoc-landing .offers-bento {\n    grid-template-columns: 1fr;\n  }\n\n  .adhoc-landing .offer-card {\n    min-height: auto;\n    padding: 24px;\n  }\n\n  .adhoc-landing .offer-card-heart,\n  .adhoc-landing .offer-card-vitals {\n    min-height: auto;\n  }\n\n  .adhoc-landing .how-rail-line {\n    top: 0;\n    bottom: 0;\n    left: 25px;\n    right: auto;\n    width: 1px;\n    height: auto;\n    background: linear-gradient(\n      180deg,\n      transparent 0%,\n      var(--panel-line) 6%,\n      var(--teal) 50%,\n      var(--panel-line) 94%,\n      transparent 100%\n    );\n  }\n\n  .adhoc-landing .how-steps {\n    grid-template-columns: 1fr;\n    gap: 36px;\n    padding-left: 12px;\n  }\n\n  .adhoc-landing .how-step {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    grid-template-rows: auto auto;\n    column-gap: 20px;\n    row-gap: 6px;\n    text-align: left;\n    padding: 0 0 0 8px;\n  }\n\n  .adhoc-landing .how-step-marker {\n    grid-row: 1 / span 2;\n    margin-bottom: 0;\n    align-self: start;\n  }\n\n  .adhoc-landing .how-step-index {\n    display: none;\n  }\n\n  .adhoc-landing .how-step h3 {\n    align-self: end;\n    margin-bottom: 0;\n  }\n\n  .adhoc-landing .how-step p {\n    max-width: none;\n    margin: 0;\n  }\n\n  .adhoc-landing .science-grid {\n    grid-template-columns: 1fr;\n    gap: 36px;\n  }\n\n  .adhoc-landing .science-media {\n    min-height: 220px;\n  }\n\n  .adhoc-landing .journey-cta-wrap {\n    padding: 0 20px;\n  }\n\n  .adhoc-landing .journey-card {\n    padding: 32px 24px 28px;\n    border-radius: 22px;\n  }\n\n  .adhoc-landing .journey-offer-row {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .adhoc-landing .journey-offer-box {\n    text-align: center;\n  }\n\n  .adhoc-landing .facts {\n    border-left: none;\n    padding-left: 0;\n  }\n\n  .adhoc-landing .fact::before {\n    left: 0;\n  }\n\n  .adhoc-landing .fact {\n    padding-left: 24px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .adhoc-landing .glow,\n  .adhoc-landing .scan-line,\n  .adhoc-landing .wave,\n  .adhoc-landing .science-wave {\n    animation: none !important;\n  }\n\n  .adhoc-landing .science-wave {\n    stroke-dashoffset: 0;\n  }\n\n  .adhoc-landing .scan-line {\n    transform: translateY(160px);\n  }\n\n  .adhoc-landing .wave {\n    stroke-dashoffset: 0;\n  }\n}\n\n.adhoc-landing .flow-privacy-note,\n.adhoc-landing .auth-legal-note {\n  margin: 16px 0 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: #64748b;\n  text-align: center;\n}\n\n.adhoc-landing .privacy-inline-link {\n  color: #12a594;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.adhoc-landing .privacy-inline-link:hover {\n  color: #0b3b4f;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
